import { PreviewTermPlanModel } from '../models/preview_term_plan_model';

import { IDefineCommand } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
angular
  .module('capability-ng-academic-planner')
  .service(
    'clearTermPreviewPlanCommand',
    function clearTermPreviewPlanCommand(
      $http: ng.IHttpService,
      log: any,
      ngPreviewTermPlanModel: PreviewTermPlanModel,
      defineCommand: IDefineCommand
    ) {
      return defineCommand('clearTermPreviewPlanCommand', (deferred) => {
        ngPreviewTermPlanModel.clear();
        ORM.run();
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/commands/clear_term_preview_plan_command.ts